var __TEMP__ = require('./_basePropertyOf.js');var basePropertyOf = __REQUIRE_DEFAULT__(__TEMP__);

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = escapeHtmlChar;
